'use client';
import styled from 'styled-components';

import { Sizes, Spacers } from '@styles/theme';
interface ImageContainerProps {
  $hasImage: boolean;
  height?: string;
  mobileHeight?: string;
}

export const ImageContainer = styled.div<ImageContainerProps>`
  background-color: ${({ theme }) => theme.colors.backgroundAccent};
  border-radius: ${Spacers.XS}rem;
  height: ${Sizes.LISTING_IMAGE};
  position: relative;

  ${({ $hasImage }) =>
    $hasImage &&
    `
    background-color: transparent;
  `}
`;

export const ImagePreview = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: ${Spacers.XS}rem;
`;

export const LoadingOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
`;
